import React from 'react';
import { IMAGES } from '../../data/siteContent';
type Props = {
  className?: string;
  alt?: string;
};

// The supplied M&S Travel crest is the anchor of the brand system.
export function Logo({
  className = '',
  alt = ''
}: Props) {
  return <img src={IMAGES.brandLogo} alt={alt} aria-hidden={alt ? undefined : true} loading="eager" decoding="async" className={`object-contain ${className}`} data-id="element-194" data-mp="rua1sg9v3ba6" />;
}